export default "__VITE_ASSET__CTcwC$TG__"